"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  ACTIVITY_TYPE: 'ACTIVITY_TYPE',
  ADS_FACEBOOK_ADGROUP: 'ADS_FACEBOOK_ADGROUP',
  ADS_FACEBOOK_AD: 'ADS_FACEBOOK_AD',
  ADS_FACEBOOK_CAMPAIGN: 'ADS_FACEBOOK_CAMPAIGN',
  ADS_GOOGLE_ADGROUP: 'ADS_GOOGLE_ADGROUP',
  ADS_GOOGLE_AD: 'ADS_GOOGLE_AD',
  ADS_GOOGLE_CAMPAIGN: 'ADS_GOOGLE_CAMPAIGN',
  ADS_GOOGLE_KEYWORD: 'ADS_GOOGLE_KEYWORD',
  ADS_LINKEDIN_ADGROUP: 'ADS_LINKEDIN_ADGROUP',
  ADS_LINKEDIN_AD: 'ADS_LINKEDIN_AD',
  ADS_LINKEDIN_CAMPAIGN: 'ADS_LINKEDIN_CAMPAIGN',
  ADS_PROPERTY: 'ADS_PROPERTY',
  ALL_WORKFLOW: 'ALL_WORKFLOW',
  ANALYTICS_VIEW: 'ANALYTICS_VIEW',
  APP_USER: 'APP_USER',
  AUTOMATION_PLATFORM_WORKFLOWS: 'AUTOMATION_PLATFORM_WORKFLOWS',
  ASSIGNABLE_OWNER: 'ASSIGNABLE_OWNER',
  ASSIGNABLE_USER: 'ASSIGNABLE_USER',
  BLOG_POST: 'BLOG_POST',
  BLOGS: 'BLOGS',
  BLOG_AUTHOR: 'BLOG_AUTHOR',
  BLOG_TAG: 'BLOG_TAG',
  CALL_DISPOSITION: 'CALL_DISPOSITION',
  CAMPAIGN: 'CAMPAIGN',
  COMPANIES_SAVED_FILTERS: 'COMPANIES_SAVED_FILTERS',
  COMPANY: 'COMPANY',
  COMPANY_PROPERTY: 'COMPANY_PROPERTY',
  CONTACT_LIST: 'CONTACT_LIST',
  CONTACT_PROPERTY: 'CONTACT_PROPERTY',
  CONTACT_STATIC_LIST: 'CONTACT_STATIC_LIST',
  CONTACT: 'CONTACT',
  CONTACT_BY_EMAIL: 'CONTACT_BY_EMAIL',
  CONTACTS_SAVED_FILTERS: 'CONTACTS_SAVED_FILTERS',
  CTA: 'CTA',
  CTA_TO_PLACEMENT: 'CTA_TO_PLACEMENT',
  DEAL_PIPELINE_STAGE: 'DEAL_PIPELINE_STAGE',
  DEAL_PIPELINE: 'DEAL_PIPELINE',
  DEAL: 'DEAL',
  DEAL_PROPERTY: 'DEAL_PROPERTY',
  DEALS_SAVED_FILTERS: 'DEALS_SAVED_FILTERS',
  ECOMMERCE_APP: 'ECOMMERCE_APP',
  ECOMMERCE_STORE: 'ECOMMERCE_STORE',
  EMAIL: 'EMAIL',
  EMAIL_CAMPAIGN: 'EMAIL_CAMPAIGN',
  EMAIL_CAMPAIGN_URL: 'EMAIL_CAMPAIGN_URL',
  EMAIL_SUBSCRIPTION: 'EMAIL_SUBSCRIPTION',
  ENGAGEMENT: 'ENGAGEMENT',
  ENGAGEMENT_PROPERTY: 'ENGAGEMENT_PROPERTY',
  EVENT: 'EVENT',
  FEEDBACK_FORM: 'FEEDBACK_FORM',
  FEEDBACK: 'FEEDBACK',
  FORM: 'FORM',
  HIERARCHICAL_TEAM: 'HIERARCHICAL_TEAM',
  IMPORT_NAME: 'IMPORT_NAME',
  INBOUND_DB_COMPANY_IMPORT: 'INBOUND_DB_COMPANY_IMPORT',
  INBOUND_DB_CONTACT_IMPORT: 'INBOUND_DB_CONTACT_IMPORT',
  INBOUND_DB_DEAL_IMPORT: 'INBOUND_DB_DEAL_IMPORT',
  INTEGRATION: 'INTEGRATION',
  INTEGRATION_NAME: 'INTEGRATION_NAME',
  INTEGRATION_PROPERTY: 'INTEGRATION_PROPERTY',
  KNOWLEDGE_ARTICLES: 'KNOWLEDGE_ARTICLES',
  LANDING_PAGE: 'LANDING_PAGE',
  LEAD_FLOW: 'LEAD_FLOW',
  LINE_ITEM: 'LINE_ITEM',
  LINE_ITEM_PROPERTY: 'LINE_ITEM_PROPERTY',
  MULTI_CURRENCY_CURRENCY_CODE: 'MULTI_CURRENCY_CURRENCY_CODE',
  MULTI_CURRENCY_INFORMATION: 'MULTI_CURRENCY_INFORMATION',
  OWNER: 'OWNER',
  PERSONA: 'PERSONA',
  PRODUCT: 'PRODUCT',
  PRODUCT_FOLDER: 'PRODUCT_FOLDER',
  PRODUCT_PROPERTY: 'PRODUCT_PROPERTY',
  PROPERTY_GROUP: 'PROPERTY_GROUP',
  QUOTE: 'QUOTE',
  QUOTE_PROPERTY: 'QUOTE_PROPERTY',
  SALESFORCE_CAMPAIGN: 'SALESFORCE_CAMPAIGN',
  SALESFORCE_CAMPAIGN_LIST: 'SALESFORCE_CAMPAIGN_LIST',
  SITE_CONTENT: 'SITE_CONTENT',
  SITE_PAGE: 'SITE_PAGE',
  SLACK_CHANNEL: 'SLACK_CHANNEL',
  SLACK_USER: 'SLACK_USER',
  SNIPPETS: 'SNIPPETS',
  SURVEY_QUESTION: 'SURVEY_QUESTION',
  SURVEY_SETTING: 'SURVEY_SETTING',
  SURVEY: 'SURVEY',
  TASK: 'TASK',
  TEAM: 'TEAM',
  TICKET: 'TICKET',
  TICKET_PIPELINE: 'TICKET_PIPELINE',
  TICKET_PROPERTY: 'TICKET_PROPERTY',
  TICKET_STAGE: 'TICKET_STAGE',
  USER: 'USER',
  WEBINAR: 'WEBINAR',
  WEBINAR_SETTING: 'WEBINAR_SETTING',
  WORKFLOW: 'WORKFLOW',
  WORKFLOW_SALESFORCE: 'WORKFLOW_SALESFORCE'
};
exports.default = _default;
module.exports = exports.default;